import type {ReactNode} from 'react';
import {DrawReference} from '@platform/ui/DrawReference';
import {drawNumber} from '@platform/contracts/drawNumber';
import type {Snapshot} from '@platform/contracts/x';
import {useCopy} from '@platform/ui/config';
import {BottomCta} from './BottomCta';
import {BottomCtaNavigation} from './BottomCtaNavigation';
import {useOwnedCardsMeta} from './useOwnedCardsMeta';

// Both viewers and participants keep the draw while buying quickly; the
// separate catalogue action also exposes their accepted cards for the next draw.
export function NextDrawAction({state,onBuy,onInspect,label,finished=false,disabled=false,quickDisabled=false,resumeAction}:{state:Snapshot;onBuy:()=>void;onInspect:()=>void;label:string;finished?:boolean;disabled?:boolean;quickDisabled?:boolean;resumeAction?:ReactNode}){
 const t=useCopy(),ownedMeta=useOwnedCardsMeta(state),personal=ownedMeta.text;
 return <BottomCta expansion={resumeAction} className="room-next-action" revealKey={state.drawId+':'+finished} handleLabel={t('flow.nextDrawHeading')} handleDetail={<DrawReference draw={drawNumber(state)}/>} handleMeta={ownedMeta} data-ui="room-next-action">
  <BottomCtaNavigation finished={finished} state={state} onQuick={onBuy} quickLabel={label} onNavigate={onInspect} disabled={disabled} quickDisabled={quickDisabled} navigationLabel={t('room.nextSelectionDraw',{draw:drawNumber(state)})+' · '+t('flow.chooseCard')+' · '+personal}/>
 </BottomCta>;
}

// The fixed action area remains present while the server prepares a new offer.
// Do not show a purchasable draw or a countdown until one actually exists.
export function NextDrawWaiting({drawId}:{drawId:string}){
 const t=useCopy();
 return <BottomCta className="room-next-action" revealKey={drawId} data-ui="room-next-waiting"><p className="next-draw-waiting" role="status">{t('flow.nextPreparing')}</p></BottomCta>;
}
